<template>
    <v-flex xs12 md6 class="events"
            :class="{'mt-4': $vuetify.breakpoint.smAndDown}"
    >
        <h2 class="section-title">{{$t("События")}}</h2>
        <v-layout column class="events-block">
            <v-carousel class="events__courses" v-if="news && news.length > 0" hide-delimiters light height="176px">
                <v-carousel-item
                    v-for="(item,i) in news"
                    :key="i"
                    class="events__slider"
                >
                    <a class="news-item__link" @click.prevent="go_to_detail(item.id)">
                        <v-layout
                            :class="{
                                'column': $vuetify.breakpoint.xs,
                                'row align-center justify-center': $vuetify.breakpoint.smAndUp,
                                'py-3 px-4': $vuetify.breakpoint.lgAndDown,
                                'pa-4': $vuetify.breakpoint.xlAndUp
                            }"
                        >
                            <div md3 xs12 class="events__courses-date text-sm-center text-xs-left"
                                 :class="{'layout px-4 mx-0 align-center': $vuetify.breakpoint.xs, 'flex px-3': $vuetify.breakpoint.smAndUp}"
                            >
                                <div class="mr-2">{{ day(item.date) }}</div>
                                <v-flex class="events__courses-date-label">{{ $t(month(item.date)) }}</v-flex>
                            </div>
                            <v-flex
                                md9
                                xs12
                                :class="{'px-4': $vuetify.breakpoint.xs, 'pr-5': $vuetify.breakpoint.smAndUp}"
                            >
                                <div class="events__courses-title" v-html="event_title(item) ">  </div>
                                <div class="events__courses-text" v-html="event_text(item)">  </div>
                            </v-flex>
                        </v-layout>
                    </a>
                </v-carousel-item>
            </v-carousel>
            <v-carousel class="wrapper-relative events__db" v-if="$vuetify.breakpoint.mdAndUp" hide-delimiters height="244px">
                <v-carousel-item
                    v-for="(item, i) in items2"
                    :key="i"
                    :src="item.src"
                    class="events__slider-overlay"
                    @click="check_click(item)"
                >
                    <labelTopic class="section-label--green mt-4" bg_color="#559a2b">{{$t("База знаний")}}</labelTopic>
                    <v-layout class="events__db-content pt-4 px-5">
                        <div class="events__db-text mt-3">{{ $t(item.text) }}</div>
                    </v-layout>
                </v-carousel-item>
            </v-carousel>
            <div v-else class="ideas-slider slider wrapper-relative events__db">
                <v-carousel hide-controls height="58.2222%">
                    <v-carousel-item
                        v-for="(item,i) in items2"
                        :key="i"
                        :src="item.src"
                        class="py-3 events__slider-overlay"
                    >
                        <labelTopic class="section-label--green" bg_color="#559a2b">{{$t("База знаний")}}</labelTopic>
                        <v-layout class="events__db-content pt-4">
                            <div class="events__db-text mt-3">{{ item.text }}</div>
                        </v-layout>
                    </v-carousel-item>
                </v-carousel>
            </div>
        </v-layout>
    </v-flex>
</template>

<script>
import labelTopic from '@/components/ui/labels/label_topic.vue';
import { mapGetters, mapActions} from 'vuex';
import dayjs from 'dayjs';
import ru from 'dayjs/locale/ru';
export default {
  components: {
    labelTopic,
  },
  data() {
    return {
      items2: [
        {
          id  : 1,
          src : '/images/slider_1.jpg',
          text: 'Международные классификации',
          type: '#classification',
        },
        {
          id  : 2,
          src : '/images/slider_2.jpg',
          text: 'Спецификации ОЕМ',
          type: '#oem',
        },
        {
          id  : 3,
          src : '/images/slider_3.jpg',
          text: 'Продуктовый портфель',
          type: '#products',
        },
        {
          id  : 4,
          src : '/images/slider_4.jpg',
          text: 'Глоссарий',
          type: '#glossary',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('news_main', [
      'news',
    ]),
    ...mapGetters('events', [
      'events',
    ]),
  },
  mounted() {
    this.get_news();
  },
  methods: {
    ...mapActions('news_main', [
      'get_news',
    ]),
    check_click(item) {
      this.$router.push({name: 'database', hash: item.type});
    },
    go_to_detail(id) {
      this.$router.push({name: 'news_descript', params: {id: id}});
    },
    day(date) {
      return new dayjs(date).format('DD');
    },
    month(date) {
      let month = new dayjs(date, {locale: ru}).format('MMMM');
      let shortmonth = month.slice(0, month.length-1);
      if (month.toLowerCase()!='март' && month.toLowerCase()!='август') {
        return shortmonth + 'я';
      } else {
        return month + 'а';
      }
    },
    event_title(item) {
      let title = item.title || 0;
      if (this.$vuetify.breakpoint.xs) {
        title = item.title.charAt(0) + item.title.slice(1).toLowerCase();
      }
      return title.length > 35 ? title.slice(0, 35)+'...' : title;
    },
    event_text(item) {
      let text = item.text || 0;
      if (this.$vuetify.breakpoint.xs && text.length > 90) {
        return text.slice(0, 70)+'...';
      } else if (text.length > 160) {
        return text.slice(0, 120)+'...';
      } else return text;
    },
  },
};
</script>

<style>
.events__slider-overlay .v-image__image--cover {
    background-size: cover;
}
</style>
